@if (invoices && invoices.length > 0) {
  <div class="paid-invoices">
    <table mat-table [dataSource]="invoices" [trackBy]="trackByFn" class="paid-invoices__table mat-elevation-z1">
      <ng-container matColumnDef="recordId">
        <th mat-header-cell *matHeaderCellDef class="paid-invoices__th">Invoice No.</th>
        <td mat-cell *matCellDef="let row" class="paid-invoices__td"><div class="paid-invoices__view" (click)="viewInvoice(row)">{{ row.recordId }}</div></td>
        <td mat-footer-cell *matFooterCellDef class="paid-invoices__td"></td>
      </ng-container>
      <ng-container matColumnDef="datePosted">
        <th mat-header-cell *matHeaderCellDef class="paid-invoices__th">Invoice Date</th>
        <td mat-cell *matCellDef="let row" class="paid-invoices__td">
          {{ row.datePosted | date:'M/d/yyyy' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="paid-invoices__td"></td>
      </ng-container>
      <ng-container matColumnDef="datePaid">
        <th mat-header-cell *matHeaderCellDef class="paid-invoices__th">Paid On</th>
        <td mat-cell *matCellDef="let row" class="paid-invoices__td">
          {{ row.datePaid | date:'M/d/yyyy' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="paid-invoices__total-label">Total</td>
      </ng-container>
      <ng-container matColumnDef="totalPaid">
        <th mat-header-cell *matHeaderCellDef class="paid-invoices__th">Invoice Amount</th>
        <td mat-cell *matCellDef="let row" class="paid-invoices__td paid-invoices__td--amount">
          {{ row.totalPaid | currency:row.baseCurrency:'symbol':'1.2-2' }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="paid-invoices__total-value paid-invoices__td--amount">
          {{ totalAmount | currency:currency:'symbol':'1.2-2' }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="paid-invoices__tr"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" class="paid-invoices__tr"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns" class="paid-invoices__tr"></tr>
    </table>
  </div>
}

<div>
  @if (invoices && invoices.length === 0) {
    <p class="paid_invoices__not-found">No paid invoices found.</p>
  }
</div>